import { useIntl } from 'react-intl';
import DialogTitle from '@rossum/components/dialog-title/DialogTitle';
import { Dialog } from '@rossum/ui/material';
import { TokenOwnerDialogContent } from './TokenOwnerDialogContent';

const DIALOG_MAX_WIDTH = 448;

type TokenOwnerDialogProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (tokenOwner: string) => void;
  submitting: boolean;
  dataCy: string;
};

export const TokenOwnerDialog = ({
  open,
  onClose,
  onSubmit,
  submitting,
  dataCy,
}: TokenOwnerDialogProps) => {
  const intl = useIntl();

  return (
    <>
      {open && <div data-cy={dataCy} />}
      <Dialog
        open={open}
        onClose={onClose}
        slotProps={{
          paper: {
            sx: { width: DIALOG_MAX_WIDTH, position: 'fixed' },
            elevation: 2,
          },
        }}
      >
        {open && (
          <>
            <DialogTitle
              title={intl.formatMessage({
                id: `components.tokenOwnerDialog.title`,
              })}
              onClose={onClose}
            />
            <TokenOwnerDialogContent
              onSubmit={onSubmit}
              submitting={submitting}
              onClose={onClose}
            />
          </>
        )}
      </Dialog>
    </>
  );
};
